import { render, staticRenderFns } from "./TransferConfirm.vue?vue&type=template&id=0f020b28&scoped=true&"
import script from "./TransferConfirm.vue?vue&type=script&lang=js&"
export * from "./TransferConfirm.vue?vue&type=script&lang=js&"
import style0 from "./TransferConfirm.vue?vue&type=style&index=0&id=0f020b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f020b28",
  null
  
)

/* custom blocks */
import block0 from "./TransferConfirm.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)
import block1 from "./TransferConfirm.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VApp,VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VContainer,VProgressLinear,VRadio,VRadioGroup,VRow,VSlideYTransition,VSpacer})
